import { GqlOptionsRegistration, GqlWarrantProgram } from '../../../../../graphql/base-types.graphql';
import { OrStepSubscribers } from '../../../common/components/steps/or-subscribers';
import { Stack } from '@startuptools/ui/Stack';

export const SnrBasedStepParticipants = ({
  warrantProgram,
}: {
  warrantProgram: Pick<GqlWarrantProgram, 'id' | 'warrantStartDate' | 'warrantEndDate'> & {
    optionsRegistrations: Pick<GqlOptionsRegistration, 'id'>[];
  };
}) => {
  return (
    <Stack gap={3}>
      {/* a little bit hacky props until the regular warrant stepper is fully converted */}
      <OrStepSubscribers
        wpId={warrantProgram.id}
        orId={warrantProgram.optionsRegistrations[0]!.id}
        navigateToDecisionStep={() => null}
      />
    </Stack>
  );
};
